class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.hiddenBackgroundElements = [];

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');
    this.hideBackgroundFromAssistiveTech();

    this.notification.addEventListener(
      'transitionend',
      () => {
        const focusTarget = this.notification.querySelector('.cart-notification__close') || this.notification;
        trapFocus(this.notification, focusTarget);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);
    this.restoreBackgroundForAssistiveTech();

    removeTrapFocus(this.activeElement);
  }

  hideBackgroundFromAssistiveTech() {
    this.restoreBackgroundForAssistiveTech();

    const cartNotificationRoot = this.closest('cart-notification');

    const elementsToHide = new Set();
    let currentElement = cartNotificationRoot;

    while (currentElement && currentElement !== document.body) {
      Array.from(currentElement.parentElement.children).forEach((sibling) => {
        if (sibling !== currentElement && !sibling.contains(cartNotificationRoot)) {
          elementsToHide.add(sibling);
        }
      });

      currentElement = currentElement.parentElement;
    }

    this.hiddenBackgroundElements = Array.from(elementsToHide);

    this.hiddenBackgroundElements.forEach((element) => {
      element.setAttribute('data-cart-notification-aria-hidden', element.getAttribute('aria-hidden') || '');
      element.setAttribute('aria-hidden', 'true');

      if ('inert' in element) {
        element.setAttribute('data-cart-notification-inert', element.inert ? 'true' : 'false');
        element.inert = true;
      }
    });
  }

  restoreBackgroundForAssistiveTech() {
    if (!this.hiddenBackgroundElements?.length) return;

    this.hiddenBackgroundElements.forEach((element) => {
      if (!document.contains(element)) return;

      const previousAriaHidden = element.getAttribute('data-cart-notification-aria-hidden');

      if (previousAriaHidden) {
        element.setAttribute('aria-hidden', previousAriaHidden);
      } else {
        element.removeAttribute('aria-hidden');
      }

      element.removeAttribute('data-cart-notification-aria-hidden');

      if (element.hasAttribute('data-cart-notification-inert')) {
        element.inert = element.getAttribute('data-cart-notification-inert') === 'true';
        element.removeAttribute('data-cart-notification-inert');
      }
    });

    this.hiddenBackgroundElements = [];
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
